import script from "./IncomingCallModal.vue?vue&type=script&setup=true&lang=js"
export * from "./IncomingCallModal.vue?vue&type=script&setup=true&lang=js"

import "./IncomingCallModal.vue?vue&type=style&index=0&id=121bd76c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-121bd76c"]])

export default __exports__